import {useMemo} from "react";
import {invoiceGroupBysSelector, useGetAllInvoiceGroupBysQuery} from "@ots-frontend/ots-data";
import {BaseSelect, BaseSelectProps} from "../../base-select";

type Props = Omit<BaseSelectProps, "data">

export const InvoiceGroupBySelect = (props: Props) => {
  const {...rest} = props;

  const selectInvoiceGroupBys = useMemo(() => {
    return invoiceGroupBysSelector();
  }, []);

  const {data, isLoading} = useGetAllInvoiceGroupBysQuery(undefined, {
    selectFromResult: (result) => ({
      data: selectInvoiceGroupBys(result),
      isLoading: result.isLoading
    })
  });

  const sortedData = useMemo(() => {
    return [...data].sort();
  }, [data]);

  return (
    <BaseSelect
      data={sortedData}
      loading={isLoading}
      {...rest} />
  );
};
